<!-- <div class="font-18">Consent Details</div> -->
@if (consent.patientData) {
  <div class="my-4">
    <div class="font-14">Patient Details</div>
    <app-edit-patient
      [patient]="consent.patientData"
      [canSave]="false"
      [editMode]="false"
      [alignment]="'vertical'"
    ></app-edit-patient>
  </div>
}
@if (!consent.patientData) {
  <div>This Consent has no Patient</div>
}
